import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

export const sentryInitialization = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN || '',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
    ],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || '',
    tracesSampleRate: 0.1,
    // Session Replay is intentionally not enabled (GROW-4182): its DOM
    // serialization blocked the main thread on data-heavy pages.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
};
